import { V4, debug } from '@moleculeone/utils';

import * as Drawing from '../const';
import { positionsDataTest } from '../checks';
import { getSmallestCycles } from '../selectors';
import { geometryIndices } from '../isomerism';
import { addGroup, geometryBondGroupKey, tripleBondGroupKey } from './utils';

function addTripleBondGroup(positionsData, bond) {
  const neighbors = positionsData.neighbors;
  const newGroup = {};
  newGroup[bond.start] = V4.vect(-50, 0);
  newGroup[bond.end] = V4.vect(50, 0);
  if (neighbors[bond.start].length === 2) {
    const other = neighbors[bond.start].filter(([b, a]) => a.idx !== bond.end)[0][1];
    newGroup[other.idx] = V4.vect(-150, 0);
  }
  if (neighbors[bond.end].length === 2) {
    const other = neighbors[bond.end].filter(([b, a]) => a.idx !== bond.start)[0][1];
    newGroup[other.idx] = V4.vect(150, 0);
  }

  const gIdx = tripleBondGroupKey(bond.idx);
  addGroup(positionsData, gIdx, newGroup);
}

function addGeometryBondGroup(positionsData, bond) {
  const neighbors = positionsData.neighbors;
  const newGroup = {};
  newGroup[bond.start] = V4.vect(-50, 0);
  const [start1, start2] = geometryIndices(neighbors, bond.start, bond.end);
  if (start1 !== bond.start) {
    newGroup[start1] = V4.vect(-50 - 100 / 2.0, (100 * Math.sqrt(3)) / 2);
  }
  if (start2 !== bond.start) {
    newGroup[start2] = V4.vect(-50 - 100 / 2.0, (-100 * Math.sqrt(3)) / 2);
  }

  const flip = bond.geometry === Drawing.TRANS ? -1 : 1;
  newGroup[bond.end] = V4.vect(50, 0);
  const [end1, end2] = geometryIndices(neighbors, bond.end, bond.start);
  if (end1 !== bond.end) {
    newGroup[end1] = V4.vect(50 + 100 / 2.0, (flip * 100 * Math.sqrt(3)) / 2);
  }
  if (end2 !== bond.end) {
    newGroup[end2] = V4.vect(50 + 100 / 2.0, (-flip * 100 * Math.sqrt(3)) / 2);
  }
  const gIdx = geometryBondGroupKey(bond.idx);
  addGroup(positionsData, gIdx, newGroup);
}

export function addSpecialBondGroups(positionsData) {
  const { bondToCycle } = getSmallestCycles(positionsData.mol);
  for (const bond of Object.values(positionsData.mol.bonds)) {
    const cycle = bondToCycle[bond.idx];
    if (bond.order === 3 && (cycle == null || cycle.length > 8)) {
      addTripleBondGroup(positionsData, bond);
    }
    if (bond.order === 2 && bond.geometry != null && (cycle == null || cycle.length > 6)) {
      addGeometryBondGroup(positionsData, bond);
    }
  }
  debug(positionsDataTest, positionsData);
}
